import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../services/api";
import { API_ENDPOINTS } from "../constants/actionTypes";

// Thunk for Fetching Track Status
export const fetchTrackStatus = createAsyncThunk(
  "track/fetchStatus",
  async (trackId, { rejectWithValue }) => {
    try {
      // NOTE: Using the generic GET method without token if needed
      // Depending on API configuration, this might work via standard interceptor
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.TRACK.GET_STATUS}/${trackId}`,
      );
      return response.data;
    } catch (error) {
      console.error("fetchTrackStatus error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          "Failed to fetch track status. Please check your tracking ID.",
      );
    }
  },
);

const trackSlice = createSlice({
  name: "track",
  initialState: {
    trackData: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearTrackState: (state) => {
      state.trackData = null;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrackStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.trackData = null;
      })
      .addCase(fetchTrackStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const apiData = action.payload?.data;
        state.trackData = apiData || action.payload;
      })
      .addCase(fetchTrackStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTrackState } = trackSlice.actions;
export default trackSlice.reducer;
